/**
 * Secure-by-Design AI Control Library — global catalog + per-tenant posture.
 */

const IMPL = ['not_implemented', 'in_progress', 'implemented', 'not_applicable'];
const TEST = ['not_tested', 'pass', 'fail'];

function fwChips(map) {
  const out = [];
  for (const [fw, refs] of Object.entries(map || {})) {
    if (Array.isArray(refs) && refs.length) {
      out.push(`<span class="badge badge-info" title="${fw}">${fw.replace(/_/g, ' ').toUpperCase()}: ${refs.join(', ')}</span>`);
    }
  }
  return out.join(' ');
}

export const aiControls = {
  async aiControls() {
    let res = { data: [] };
    try { res = await API.getAiControls(); } catch (e) { /* empty */ }
    const controls = res.data || [];
    this._controls = controls;

    const implemented = controls.filter(c => c.implementation_status === 'implemented').length;
    const rows = controls.map(c => `
      <tr>
        <td><strong>${c.control_code}</strong></td>
        <td>${c.name}<div class="muted" style="font-size:12px">${App.formatLabel(c.category)}</div></td>
        <td style="max-width:280px">${fwChips(c.framework_mappings)}</td>
        <td>${App.badge(c.implementation_status)}</td>
        <td>${App.badge(c.test_status)}</td>
        <td><button class="btn btn-sm btn-outline" data-action="Pages.setControlStatus" data-a0="${c.id}">Set Status</button></td>
      </tr>`).join('');

    return `
      <div class="page-header">
        <div><h2>Secure-by-Design AI Controls</h2>
        <p>AI control library mapped to NIST AI RMF, NIST 800-53, HIPAA, OWASP LLM Top 10, and MITRE ATLAS</p></div>
      </div>
      <div class="stats-row">
        <div class="stat-card info"><div class="stat-value">${controls.length}</div><div class="stat-label">Catalog Controls</div></div>
        <div class="stat-card success"><div class="stat-value">${implemented}</div><div class="stat-label">Implemented</div></div>
        <div class="stat-card warning"><div class="stat-value">${controls.length - implemented}</div><div class="stat-label">Outstanding</div></div>
      </div>
      <div class="card" style="margin-top:16px">
        <div class="table-container">
          <table class="data-table">
            <thead><tr><th>ID</th><th>Control</th><th>Framework Mapping</th><th>Implementation</th><th>Test</th><th></th></tr></thead>
            <tbody>${rows}</tbody>
          </table>
        </div>
      </div>`;
  },

  setControlStatus(id) {
    const c = (this._controls || []).find(x => x.id === id);
    if (!c) return;
    const opt = (arr, sel) => arr.map(v => `<option value="${v}" ${v === sel ? 'selected' : ''}>${App.formatLabel(v)}</option>`).join('');
    const body = `
      <p><strong>${c.control_code}</strong> — ${c.name}</p>
      <p class="muted" style="font-size:13px">${c.description || ''}</p>
      <div class="form-group"><label>Implementation status</label>
        <select id="cs-impl" class="form-control">${opt(IMPL, c.implementation_status)}</select></div>
      <div class="form-group"><label>Test status</label>
        <select id="cs-test" class="form-control">${opt(TEST, c.test_status)}</select></div>
      <div class="form-group"><label>Next review date</label>
        <input id="cs-next" type="date" class="form-control" value="${c.next_review_date || ''}"></div>
      <div class="form-group"><label>Notes</label>
        <textarea id="cs-notes" class="form-control" rows="2">${c.notes || ''}</textarea></div>
      <input type="hidden" id="cs-id" value="${c.id}">`;
    const footer = `
      <button class="btn btn-outline" data-action="App.closeModal">Cancel</button>
      <button class="btn btn-primary" data-action="Pages.submitControlStatus">Save Posture</button>`;
    App.openModal('AI Control Posture', body, footer);
  },

  async submitControlStatus() {
    const val = (id) => document.getElementById(id)?.value || '';
    const body = {
      ai_control_id: val('cs-id'),
      implementation_status: val('cs-impl'),
      test_status: val('cs-test'),
      next_review_date: val('cs-next') || null,
      last_reviewed_date: new Date().toISOString().slice(0, 10),
      notes: val('cs-notes') || null,
    };
    try {
      await API.upsertAiControlStatus(body);
      App.closeModal();
      App.toast('Control posture saved', 'success');
      App.navigate('ai-controls');
    } catch (e) { App.toast(e.message || 'Failed to save', 'error'); }
  },
};
